import React from 'react';
import { 
  Home, Activity, FileText, TrendingUp, Boxes, Factory, BookOpen, Calculator, Layers, ShoppingCart, ClipboardCheck, BarChart2, DollarSign, GraduationCap
} from 'lucide-react';

const iconMap = {
  Home,
  Activity,
  FileText,
  TrendingUp,
  Boxes,
  Factory,
  BookOpen,
  Calculator,
  Layers,
  ShoppingCart,
  ClipboardCheck,
  BarChart2,
  DollarSign,
  GraduationCap
};

const Navigation = ({ tabs, activeTab, setActiveTab }) => {

  return (
    <div className="bg-white p-1 rounded-lg shadow-sm mb-6">
      <div className="flex flex-wrap gap-1">
        {tabs.map((tab) => {
          const Icon = iconMap[tab.icon];
          return (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex items-center space-x-2 px-3 py-2 text-sm rounded-md font-medium transition-colors ${
                activeTab === tab.id
                  ? 'bg-blue-600 text-white'
                  : 'text-gray-600 hover:text-gray-800 hover:bg-gray-50'
              }`}
            >
              <Icon className="w-4 h-4" />
              <span>{tab.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default Navigation; 